import { Actions } from 'flummox';
import playlists from '../playlists';

export default class PlaylistActions extends Actions {
  play(playlistKey) {
    if (!playlistKey) { return false; }

    return playlistKey;
  }
  stop() { return false; }
  next() { return true; }

  updateCurrentTime(time) { return time; }

  randomPlaylist() {
    const keys = Object.keys(playlists);
    const index = Math.floor(Math.random() * keys.length);
    const key = keys[index];

    return playlists[key];
  }

  getPlaylist(key) {
    return playlists[key];
  }

  async load(playlist) { // jshint ignore:line
    if (!playlist) {
      playlist = this.randomPlaylist();
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(playlist);
      }, 0);
    });
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/PlaylistActions.es6
 **/